import React, { useEffect, useState } from "react";
import * as httpClient from "../../util/httpClient";
import { updateState, states, FirstTermsStates } from "./StateManagement";
import { DialogComponent } from "../common/DialogComponent";
import TermsAndConditionDialog from "../Dialogs/T&CDialog";
import parse, { domToReact } from "html-react-parser";
import Cart from "./Cart";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import LegalDocumentContainer from "../LegalDocumentPages/LegalDocumentContainer";
import { isIDFPartnerUser } from "../../util/partner";
import PrivacyNoticeDialog from "../Dialogs/PrivacyNoticeDialog";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useButtonText } from "../commonConstants";
import { useTranslation } from "react-i18next";

interface IProps {
    displayData: any;
    manage: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
}
interface IState {
    TermsData: any;
    isAgree: boolean;
}

const Terms = ({ displayData, manage, registrationState, setRegistrationState, registrationLookup }: IProps) => {
    const { handleSubmit } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const { getTermsOfUseURL, getPrivacyNoticeURL, getPrivacyNoticeLinkText, getTermsOfUseLinkText, getPersonalInfoLinkText, personalInformationLink } = LegalDocumentContainer();
    const isDynamicFooter: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            ? state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            : false
    );
    let history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const LookupType: any = query.get("Type");
    const [Termsdialog, setTermsDialog] = useState(false);
    const [privacyDialog, setPrivacyDialog] = useState(false);

    const [state, setState] = useState<IState>({ TermsData: {}, isAgree: registrationState.billingInfo.isAgree ? registrationState.billingInfo.isAgree : false });
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const isWhiteLabeledEZSPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 540
                ? true
                : false
            : false
    );
    const termsOfUseLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            : ""
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.partnerId &&
            state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const privacyPolicyLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            : ""
    );
    const subscriberDetails = registrationLookup && registrationLookup["subscriberDetails"];
    const isTypeSSOProvisional = LookupType === "SSO_PROVISIONAL";
    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    const ShowTermsAndConditionScreenFirst: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.showTermsAndConditionScreenFirst
            : false
    );
    const handleCloseTermsDialog = (): any => {
        setTermsDialog(false);
    };
    const isInfodefenderPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 544
                ? true
                : false
            : false
    );
    const isMWBPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2664
                ? true
                : false
            : false
    );
    const isEsetGlobalPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2671
                ? true
                : false
            : false
    );
    const isNexshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 540
                ? true
                : false
            : false
    );

    const partnerSSOOptionTNCText = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerSSOOptionTNCText
            ? state.configurationState.configuration.partnerConfig.partnerSSOOptionTNCText
            : ""
    );

    let defaultTncLink: string;
    let defaultPrivacyLink: string;
    if (isMWBPartner) {
        defaultTncLink = "https://www.malwarebytes.com/eula";
        defaultPrivacyLink = "https://www.malwarebytes.com/legal/privacy-policy";
    } else {
        defaultTncLink = "https://www.sontiq.com/terms-of-use/";
        defaultPrivacyLink = "https://www.sontiq.com/privacy-policy/";
    }
    const isPreviousOrBack = useButtonText()[1];
    const checked = () => {
        if (state.isAgree) {
            setState({ ...state, isAgree: false });
            return;
        }
        setState({ ...state, isAgree: true });
    };

    const onSubmit = (data: any) => {
        setRegistrationState({ ...registrationState, billingInfo: { ...state } });
        if (isTypeSSOProvisional && ShowTermsAndConditionScreenFirst) {
            manage(updateState(FirstTermsStates, displayData.billingRequired, 2));
        } else if (isTypeSSOProvisional) {
            manage(updateState(states, displayData.billingRequired, 5));
        } else {
            manage(updateState(states, displayData.billingRequired, 3));
        }
    };

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;
            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("TermsAndConditions") !== -1) {
                    return (termsOfUseLegalDocumentLink || isIDFPartner) && !isInfodefenderPartner && !isNexshield && !isEsetGlobalPartner ? (
                        <a href={defaultTncLink} target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    ) : (
                        <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                                if (isTypeSSOProvisional) {
                                    setTermsDialog(true);
                                } else {
                                    window.open(getTermsOfUseURL(), "_blank");
                                }
                            }}
                        >
                            {getTermsOfUseLinkText()}
                        </a>
                    );
                }

                if (attribs.href && attribs.href.indexOf("privacy-policy") !== -1) {
                    return (privacyPolicyLegalDocumentLink || isIDFPartner) && !isInfodefenderPartner && !isNexshield && !isEsetGlobalPartner ? (
                        <a href={defaultPrivacyLink} target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    ) : (
                        <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                                if (isTypeSSOProvisional) {
                                    setPrivacyDialog(true);
                                } else {
                                    window.open(getPrivacyNoticeURL(), "_blank");
                                }
                            }}
                        >
                            {getPrivacyNoticeLinkText()}
                        </a>
                    );
                }
            }
        },
    };

    useEffect(() => {
        httpClient
            .sendRequest("POST", "web/termsandcondition/get-terms-and-conditions", {
                billingPrice: 0,
                SubscriptionType: "Month",
            })
            .then((data: any) => {
                if (data["hasError"]) {
                    if (data && data.status) {
                        switch (data.status) {
                            case "INTERNAL_ERROR":
                                history.push({
                                    pathname: "/register/error",
                                    state: {
                                        fromRegistration: true,
                                    },
                                });
                                break;
                            default:
                                history.push({
                                    pathname: "/register/error",
                                    state: {
                                        fromRegistration: true,
                                    },
                                });
                                break;
                        }
                    } else {
                        history.push({
                            pathname: "/register/error",
                            state: {
                                fromRegistration: true,
                            },
                        });
                    }
                } else {
                    setState({ ...state, TermsData: data });
                }
            });
    }, []);

    const setPrevious = () => {
        manage(updateState(states, displayData.billingRequired, 1));
    };

    const isIDFUser = () => {
        if (subscriberDetails && subscriberDetails["isIDFUser"]) {
            return true;
        }
        return false;
    };

    const getAgreementText = () => {
        if (!isDynamicFooter) {
            return (
                <>
                    {tLang("registration.termsOfUse.agreementText") + " "}
                    <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                            if (isTypeSSOProvisional) {
                                setTermsDialog(true);
                            } else {
                                window.open(getTermsOfUseURL(), "_blank");
                            }
                        }}
                    >
                        {(getTermsOfUseLinkText().toLowerCase() === 'terms of use') ? tLang("registration.termsOfUse.termsOfUseText") : getTermsOfUseLinkText()}
                    </a>
                    {" " + tLang("registration.termsOfUse.and") + " "}

                    <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                            if (isTypeSSOProvisional) {
                                setPrivacyDialog(true);
                            } else {
                                window.open(getPrivacyNoticeURL(), "_blank");
                            }
                        }}
                    >
                        {(getPrivacyNoticeLinkText().toLowerCase() === 'privacy notice') ? tLang("registration.termsOfUse.privacyNoticeText") : getPrivacyNoticeLinkText()}
                    </a>.

                </>
            )
        }
        else {
            return (
                <>
                    {tLang("registration.termsOfUse.agreementText") + " "}

                    <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                            if (isTypeSSOProvisional) {
                                setTermsDialog(true);
                            } else {
                                window.open(getTermsOfUseURL(), "_blank");
                            }
                        }}
                    >
                        {(getTermsOfUseLinkText().toLowerCase() === 'terms of use') ? tLang("registration.termsOfUse.termsOfUseText") : getTermsOfUseLinkText()}
                    </a>
                    {", "}

                    <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                            if (isTypeSSOProvisional) {
                                setPrivacyDialog(true);
                            } else {
                                window.open(getPrivacyNoticeURL(), "_blank");
                            }
                        }}
                    >

                        {(getPrivacyNoticeLinkText().toLowerCase() === 'privacy notice') ? tLang("registration.termsOfUse.privacyNoticeText") : getPrivacyNoticeLinkText()}
                    </a>
                    {" " + tLang("registration.termsOfUse.and") + " "}
                    <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                            if (isTypeSSOProvisional) {
                                setPrivacyDialog(true);
                            } else {
                                window.open(personalInformationLink, "_blank");
                            }
                        }}
                    >
                        {(getPersonalInfoLinkText().toLowerCase() === 'personal information we collect') ? tLang("PageFooter.label8") : getPersonalInfoLinkText()}
                    </a>.
                </>
            )
        }
    }

    return (
        <div className="row" id="content">
            <div className="col-xs">
                <div className="box box-has-shadow offset-padding">
                    <div className="box-header">
                        <div className="row box-title-container">
                            {showLogoOnRegistrationScreens && (
                                <div className="col-xs-12 col-sm-0 hide-sm-up text-align-center">
                                    <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                </div>
                            )}

                            <div className={showLogoOnRegistrationScreens ? "col-xs-12 col-sm-6" : ""}>
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName={"user"} />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">
                                        {hasSontiqBrand || isIDFUser() || isWhiteLabeledEZSPartner ? tLang("registration.termsOfUse.titleTermsOfUse") : tLang("registration.termsOfUse.titleTermsCond")}
                                    </h2>
                                </div>
                            </div>

                            {showLogoOnRegistrationScreens && (
                                <div className="col-xs-0 col-sm-6 row flex-end">
                                    <LogoContainer internalPage={false} className="hide-mobile" showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="box-content">
                        <form id="form-terms" onSubmit={handleSubmit(onSubmit)}>
                            <div className="row between-sm">
                                <div className="col-xs-12 col-sm-7 col-no-gutter">
                                    <p>
                                        {partnerSSOOptionTNCText ?
                                            partnerSSOOptionTNCText
                                            : `${tLang("registration.termsOfUse.message")} ${hasSontiqBrand || isIDFUser() || isWhiteLabeledEZSPartner ? tLang("registration.termsOfUse.titleTermsOfUse") : tLang("registration.termsOfUse.titleTermsCond")
                                            }`}
                                    </p>
                                    <div className="margin-bottom-l"></div>
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="isAgree">
                                            <input type="checkbox" id="isAgree" name="isAgree" onChange={() => checked()} checked={state.isAgree} />
                                            <span className="form-checkbox-label-text" style={{ lineHeight: "1.5rem" }}>
                                                {getAgreementText()}
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                {!isTypeSSOProvisional && (
                                    <Cart
                                        registrationLookup={registrationLookup}
                                        displayData={displayData}
                                        registrationState={registrationState}
                                        setRegistrationState={setRegistrationState}
                                        selectedCountry={registrationState.addressInfo.country}
                                    />
                                )}
                            </div>

                            <div className="margin-vertical-l"></div>

                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null"></div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <ul className="list-inline list-reset">
                                        {!ShowTermsAndConditionScreenFirst && (
                                            <li className="margin-left-s">
                                                <button type="button" className="btn-default btn-default btn-min-width" onClick={() => setPrevious()}>
                                                    <span className="btn-text">{isPreviousOrBack}</span>
                                                </button>
                                            </li>
                                        )}
                                        <li className="margin-left-s">
                                            <button
                                                type="submit"
                                                disabled={!state.isAgree}
                                                className="btn-default btn-primary btn-min-width"
                                                onClick={() => {
                                                    window.addToDataLayer({ event: "Agree and Continue Button Clicked" });
                                                }}
                                            >
                                                <span className="btn-text">{tLang("registration.termsOfUse.agreeAndContinueButtonText")}</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {Termsdialog && (
                <DialogComponent bodyClass="dialog-content width-lg" dialogId="termsDialog" title="Your cart" closeDialog={handleCloseTermsDialog}>
                    <TermsAndConditionDialog data={state.TermsData} addHeader={true}></TermsAndConditionDialog>
                </DialogComponent>
            )}
            {privacyDialog && (
                <DialogComponent
                    bodyClass="dialog-content width-lg"
                    dialogId="termsDialog"
                    title="Your cart"
                    closeDialog={() => {
                        setPrivacyDialog(false);
                    }}
                >
                    <PrivacyNoticeDialog addHeader={true}></PrivacyNoticeDialog>
                </DialogComponent>
            )}
        </div>
    );
};

export default Terms;
